import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ConstructionLanding from './pages/ConstructionLanding';
import ScrollToTop from '@/components/ScrollToTop';
import HomePage from '@/pages/HomePage';
import ProductPage from '@/pages/ProductPage';
import WorkflowPage from '@/pages/WorkflowPage';
import TechSecurityPage from '@/pages/TechSecurityPage';
import ContactPage from '@/pages/ContactPage';
import SupportPage from '@/pages/SupportPage';
import AcquisitionPortalPage from '@/pages/AcquisitionPortalPage';
import FinancialIntegrationPage from '@/pages/FinancialIntegrationPage';
import TeamPage from '@/pages/TeamPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfUsePage from '@/pages/TermsOfUsePage';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/workflow" element={<WorkflowPage />} />
          <Route path="/tech-security" element={<TechSecurityPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/acquisition-portal" element={<AcquisitionPortalPage />} />
          <Route path="/financial-integration" element={<FinancialIntegrationPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfUsePage />} />
          <Route path="/construction" element={<ConstructionLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
